import { Skeleton } from '@/components/ui/skeleton'

export const PaymentMethodFallback = () => (
  <div className="flex flex-col gap-3">
    <Skeleton className="h-9 w-full mb-2" />
    <div className="space-y-1">
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-[30%]" />
    </div>
    <div className="space-y-1">
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-full" />
      <Skeleton className="h-2 w-[80%]" />
    </div>
  </div>
)
